import { createCodeBlockFormatProvider } from '@atlaskit/editor-code-format-provider';
import type { CodeBlockFormatProvider } from '@atlaskit/editor-plugin-code-block/types';

import { expVal } from '@confluence/feature-experiments';

let codeBlockFormatProvider: ReturnType<typeof createCodeBlockFormatProvider> | undefined;

export const getCodeBlockFormatProvider = (): CodeBlockFormatProvider | undefined => {
	if (!expVal('platform_editor_code_block_q4_lovability', 'isEnabled', false)) {
		return undefined;
	}

	codeBlockFormatProvider ??= createCodeBlockFormatProvider();
	return codeBlockFormatProvider;
};
